import React, { useState } from "react";
import "./journal.css";
import CredoJouralModal from "./CredoJournalModal";
import IgniteModal from "../DailyWork/IgniteModal";
import Next30Modal from "../DailyWork/Next30Modal";
import Next90Modal from "../DailyWork/Next90Modal";
import GapmapModal from "./GapmapModal";
import Key4Modal from "./Key4Modal";

const Journal = () => {

    const [openCredo, setOpenCredo] = useState(false)
    const [openIgnition, setOpenIgnition] = useState(false)
    const [openNext30, setOpenNext30] = useState(false)
    const [openNext90, setOpenNext90] = useState(false)
    const [gapMapModal, setGapMapModal] = useState(false)
    const [key4Modal, setKey4Modal] = useState(false)


    const toggleCredo = () => {
        setOpenCredo(!openCredo)
    }

    const toggleIgnition = () => {
        setOpenIgnition(!openIgnition)
    }

    const toggleNext30 = () => {
        setOpenNext30(!openNext30)
    }

    const toggleNext90 = () => {
        setOpenNext90(!openNext90)
    }

    const toggleGapMapModal = () => {
      setGapMapModal(!gapMapModal)
    }

    const toggleKey4Modal = () => {
      setKey4Modal(!key4Modal)
    }

  return (
    <div className="">
      <div className="journal-page__content">
        <div className="journal-page-section">
          <div className="journal-page-section-header">
            <div className="journal-page-header">
              <div className="journal-page-header__eyebrow">
                Review your journey
              </div>
              <div className="journal-page-header__top">
                <div className="journal-page-header__content">
                  <div className="journal-page-header__heading">
                    <span className="jurni-font-roboto">Your Journal</span>
                  </div>
                </div>
                <div className="journal-page-header__action"></div>
              </div>
            </div>
          </div>
          {/* body */}
          <div className="journal-page-section__body">
            <div style={{ color: "#fff" }}>
              Click on any of the section below to review or edit them.
            </div>
            <div className="journal-body">
              <div className="journal-page-buttons">
                <div className="journal-page-left-buttons">
                  <button type="button" className="journal-page-next-btn" onClick={toggleCredo}>
                    <span className="journal-page-driver-button__label">
                      CREDO
                    </span>
                  </button>
                  <button type="button" className="journal-page-next-btn" onClick={toggleGapMapModal}>
                    <span className="journal-page-driver-button__label">
                      GAP MAP
                    </span>
                  </button>
                  <button type="button" className="journal-page-next-btn" onClick={toggleNext30}>
                    <span className="journal-page-driver-button__label">
                      NEXT 30
                    </span>
                  </button>
                </div>
                <div className="journal-page-right-buttons">
                  <button type="button" className="journal-page-next-btn" onClick={toggleIgnition}>
                    <span className="journal-page-driver-button__label">
                      IGNITION STATEMENT
                    </span>
                  </button>
                  <button type="button" className="journal-page-next-btn" onClick={toggleNext90}>
                    <span className="journal-page-driver-button__label">
                      NEXT 90
                    </span>
                  </button>

                  <button type="button" className="journal-page-next-btn" onClick={toggleKey4Modal}>
                    <span className="journal-page-driver-button__label">
                      KEY 4
                    </span>
                  </button>
                </div>
              </div>
              <hr
                style={{
                  marginTop: "0",
                  borderTop: "1px solid #d1b794",
                  height: "1px",
                  width: "700px",
                }}
              />
              <div className="journal-archives">
                <h4 style={{color: '#fff'}}>ARCHIVES</h4>
                <div className="archive-buttons">
                  <button type="button" className="journal-archive-page-btn">
                    <span className="journal-archive-button__label">GAP MAPS</span>
                  </button>
                  <button type="button" className="journal-archive-page-btn">
                    <span className="journal-archive-button__label">NEXT 90</span>
                  </button>
                  <button type="button" className="journal-archive-page-btn">
                    <span className="journal-archive-button__label">NEXT 30</span>
                  </button>
                  <button type="button" className="journal-archive-page-btn">
                    <span className="journal-archive-button__label">KEY 4</span>
                  </button>
                  <button type="button" className="journal-archive-page-btn">
                    <span className="journal-archive-button__label">WEEKLY REVIEWS</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <CredoJouralModal isOpen={openCredo} onClose={toggleCredo} />
      <IgniteModal isOpen={openIgnition} onClose={toggleIgnition} />
      <Next30Modal isOpen={openNext30} onClose={toggleNext30} />
      <Next90Modal isOpen={openNext90} onClose={toggleNext90} />
      <GapmapModal isOpen={gapMapModal} onClose={toggleGapMapModal} />
      <Key4Modal isOpen={key4Modal} onClose={toggleKey4Modal} />
    </div>
  );
};

export default Journal;
